
/**
 * This file has been generated from JSON file C:\Users\scale\dev\iotize\bitbucket\standalone\iotize-device-client.js\assets\schema\v1\common.json
 */ 
export default {
  "$id": "http://iotize.com/schemas/v1/common.json",
  "definitions": {
    "address": {
      "oneOf": [
        {
          "type": "integer",
          "minimum": 0,
          "default": 0,
          "examples": [192]
        },
        {
          "type": "string",
          "pattern": "^0x([0-9a-fA-F]+)$",
          "examples": ["0x2000000"]
        }
      ]
    },
    "hexString": {
      "type": "string",
      "pattern": "^0x([0-9a-fA-F]+)$",
      "examples": ["0xB3"],
      "default": "0x00"
    },
    "uint8": {
      "type": "integer",
      "minimum": 0,
      "maximum": 255,
      "description": "Unsigned integer on 8 bytes"
    },
    "uint16": {
      "type": "integer",
      "minimum": 0,
      "maximum": 65535,
      "description": "Unsigned integer on 16 bytes"
    },
    "uint32": {
      "type": "integer",
      "minimum": 0,
      "maximum": 4294967296,
      "description": "Unsigned integer on 32 bytes"
    },
    "semanticVersion": {
      "title": "SemanticVersion",
      "type": "string",
      "default": "1.0.0",
      "examples": ["1.0.0"],
      "pattern": "^(\\d+)\\.(\\d+)\\.(\\d+)$"
    },
    "IpAddressV4": {
      "title": "SemanticVersion",
      "type": "string",
      "default": "1.0.0",
      "examples": ["1.0.0"],
      "pattern": "^[0-255]\\.[0-255]\\.[0-255]\\.[0-255]$"
    }
  }
}
;
        